import { Component, computed, signal } from '@angular/core';
import { CommonModule } from '@angular/common';

import { TaxonomyDropdownComponent } from './taxonomy-dropdown/taxonomy-dropdown.component';
import { TaxonomyApiService } from '../../services/api-services/taxonomy-api.service';
import { TaxonomyService } from '../../services/taxonomy.service';
import { ActionService } from '../../services/action.service';
import { LocalTaxonomy } from './taxonomy.model';
import { TaxonomyCardComponent } from './taxonomy-card/taxonomy-card.component';
import { DropdownObjectType } from '../../shared/types';
import { TAXONOMY_FILTER_VALUES } from './taxonomy.constants';
import { Router } from '@angular/router';
import { TaxonomyCreateRequest } from './taxonomy.model';
import { NotificationService } from '../../services/notification.service';

@Component({
  selector: 'taxonomy-dashboard-v2',
  standalone: true,
  imports: [TaxonomyDropdownComponent, CommonModule, TaxonomyCardComponent],
  templateUrl: './taxonomy-dashboard-v2.component.html',
  styleUrl: './taxonomy-dashboard-v2.component.scss',
})
export class TaxonomyDashboardV2Component {
  constructor(
    public actionsService: ActionService,
    private taxonomyService: TaxonomyService,
    private taxonomyApiService: TaxonomyApiService,
    public notificationService: NotificationService,
    private router: Router
  ) {}

  _taxonomiesCards = computed<LocalTaxonomy[]>(() => this.taxonomyService._taxonomiesData());
  _searchText = signal<string>('');
  _taxonomyName = signal<string>('');
  _selectedFilter = signal<DropdownObjectType>(TAXONOMY_FILTER_VALUES[0]);
  _showNamePopup = signal<boolean>(false);

  _taxonomyId = signal<string>('');

  inputFocused = false;

  ngOnInit() {
    this.taxonomyService.loadTaxonomy();
    this.getTaxonomyCards();
  }

  onSearchChange(event: Event) {
    const el = event.target as HTMLInputElement;
    this._searchText.set(el.value);
  }

  onNameChange(event: Event) {
    const el = event.target as HTMLInputElement;
    this._taxonomyName.set(el.value);
  }

  handleFilterSelect(filter: DropdownObjectType) {
    this._selectedFilter.set(filter);
  }

  getTaxonomyCards = () => {
    let data = this._taxonomiesCards();
    const selectedFilterValue = this._selectedFilter().value;

    if (selectedFilterValue === 'published') {
      data = data.filter((i) => i.version_status === 'published');
    } else if (selectedFilterValue === 'draft') {
      data = data.filter((i) => i.version_status === 'draft');
    }

    if (this._searchText().trim()) {
      data = data.filter((i) => i.taxonomy_name.toLowerCase().includes(this._searchText().trim().toLowerCase()));
    }

    return data;
  };

  formatRouteName(name: string): string {
    return name.trim().replace(/\s+/g, '-').toLowerCase();
  }

  handleCreateTaxonomy() {
    this.taxonomyApiService
      .createTaxomonyV2({ taxonomy_name: this._taxonomyName() } as TaxonomyCreateRequest)
      .subscribe({
        next: (response) => {
          const taxonomyId = response?.id;
          if (taxonomyId) {
            this.taxonomyService.navigateToTaxonomyPage(taxonomyId);
            this.notificationService.success('Create Taxonomy', 'New Taxonomy Created');
            this.handleViewTaxonomy(taxonomyId, this._taxonomyName());
          } else {
            console.error('Taxonomy ID missing in response');
          }
        },
        error: (err) => {
          console.error('---', err);
        },
      });
  }

  handleOpenNamePopup() {
    this._showNamePopup.set(!this._showNamePopup());
  }
  handleViewTaxonomy(taxonomyId: string, taxonomyName: string) {
    const selectedValue = {
      taxonomy_id: taxonomyId,
      taxonomy_name: taxonomyName,
    };
    this.taxonomyService.setSelectedValue(selectedValue);
  }
}
